export const TID = {
  // Nav
  logoLink: "logo-link",
  langToggle: "lang-toggle",
  navAbout: "nav-about",
  navServices: "nav-services",
  navStack: "nav-stack",
  navWhy: "nav-why",
  navContact: "nav-contact",
  navCta: "nav-cta",

  // Hero
  heroPrimary: "hero-cta-primary",
  heroSecondary: "hero-cta-secondary",

  // Contact
  contactEmailBtn: "contact-email-button",
  contactLinkedinBtn: "contact-linkedin-button",
  contactFormName: "contact-form-name",
  contactFormEmail: "contact-form-email",
  contactFormMessage: "contact-form-message",
  contactFormSubmit: "contact-form-submit",
  contactFormFeedback: "contact-form-feedback",
};
